import { useCallback } from "react";

import { useRequest } from "../../../shared/hooks/useRequest";
import { getCourseStructure } from "../api/learnApi";

export const useCourseStructure = (courseId?: string) => {
    // New function only when the id changes, which re-runs the request
    const fetcher = useCallback(
        (signal: AbortSignal) => getCourseStructure(courseId as string, signal),
        [courseId]
    );

    return useRequest(courseId ? fetcher : null);
};